/**
 * Styling for code input fields
 * These utilities help create a consistent UI for code fields across components
 */

/**
 * Returns styles for code input field with optional validation state styling
 * Shows green border when valid
 * 
 * @param {boolean} isValid - Whether the input value is valid
 * @returns {Object} Style object for the TextInput component
 */
export const getCodeInputStyle = (isValid, editMode=false) => ({
    width: '100%',
    maxWidth: '400px',
    '& .MuiOutlinedInput-root': {
        ...(isValid && !editMode && {
            '& fieldset': {
                borderColor: 'green',
                borderWidth: 2,
            },
            '&:hover fieldset': {
                borderColor: 'green',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'green',
            },
        }),
    },
});
